export const MceActivityType = {
	FOLLOW_UP: 'FOLLOW_UP',
	CONSULTANCY: 'CONSULTANCY',
	SKILL_EXTENSION: 'SKILL_EXTENSION',

	values: () => {
		return ['FOLLOW_UP', 'CONSULTANCY', 'SKILL_EXTENSION'];
	},
};
